import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../../hooks/hooks';
import WebsitesComponent from '../components/website.component';
import PageLoader from '../../../../../components/PageLoader';
import { selectWebsiteCardsListItems } from '../../../../../redux/websiteCards/selector';
import { useSelector } from 'react-redux';
import { selectWebsitesListItems } from '../../../../../redux/websites/selector';
import storePersist from '../../../../../redux/storePersist';
import { websiteCards } from '../../../../../redux/websiteCards/action';
import { websites } from '../../../../../redux/websites/action';
import { stores } from '../../../../../redux/stores/action';
import { departments } from '../../../../../redux/departments/action';
import { selectStoresListItems } from '../../../../../redux/stores/selector';
import { selectDepartmentsListItems } from '../../../../../redux/departments/selector';

const AgencyWebsite = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const storeLists = useSelector(selectStoresListItems)
  const departmentLists = useSelector(selectDepartmentsListItems)
  const websiteCardsItems = useSelector(selectWebsiteCardsListItems)
  const websiteItems = useSelector(selectWebsitesListItems)
  var tenantId = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.TenantId;
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [
    selectedTenantWebsites,
    setSelectedTenantWebsites
  ] = useState<any>([])
  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedTenantWebsites({ ...selectedTenantWebsites, [field]: event });
  }

  useEffect(
    () => {

      dispatch(websiteCards.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`, entity: 'websiteCards', jsonData: {
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            },
            {
              "FieldName": "PlatformWebSiteId",
              "FieldType": "number",
              "FilterOperatorId": 1,
              "FieldValue": parmas?.id
            }
          ],
        }
      }))


    },
    []
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(websiteCards.resetAction({ actionType: 'create' }))
    await dispatch(websiteCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards`, entity: 'websiteCards', jsonData: {
        Records: [
          {
            Context: {},
            Message: {
              TenantId: tenantId,
              StoreId: selectedTenantWebsites?.StoreId,
              DepartmentId: selectedTenantWebsites?.DepartmentId,
              PlatformWebSiteId: selectedTenantWebsites?.PlatformWebSiteId,
              WebSiteName: selectedTenantWebsites?.WebSiteName,
              Remarks: selectedTenantWebsites?.Remarks,
              HostingUrl: selectedTenantWebsites?.HostingUrl,
              FQDNName:selectedTenantWebsites?.FQDNName,
              MappedDomain: selectedTenantWebsites?.MappedDomain,
              DisplayOrder: selectedTenantWebsites?.DisplayOrder,
            }
          }
        ]

      }
    }))

      .then(() => {
        back()
      })
  }

  const back = () => {
    navigate(`/agencies/cms/websites`)
  }
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'WebsiteName', headerName: 'WebsiteName',searchField: 'WebsiteName', filter: true,
        filterType: 'text'  },
      { field: 'CardName', headerName: 'CardName',searchField: 'CardName', filter: true,
        filterType: 'text'  },
      { field: 'PageName', headerName: 'PageName' ,searchField: 'PageName', filter: true,
        filterType: 'text' },
      { field: 'LayoutName', headerName: 'LayoutName' ,searchField: 'LayoutName', filter: true,
        filterType: 'text' },

    ]);
  }
  const handleSearch = (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column){
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }

    dispatch(websiteCards.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`,
      entity: 'websiteCards',
      jsonData: {
        "Filters": [
          {
            "FieldName": "TenantId",
            "FilterOperatorId": 1,
            "FieldValue": tenantId,
            "FieldType": "number"
          },
          {
            "FieldName": "PlatformWebSiteId",
            "FieldType": "number",
            "FilterOperatorId": 1,
            "FieldValue": parmas?.id
          }
        ],
      "PageNumber": 1,
      "PageSize": 50,
      "SortField": "Id",
      "SortOrder": "desc",
      "Searches": searchCriteria,
      }}))
  }
  const handleReloadData = () => {
  dispatch(websiteCards.list({
    url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`,
    entity: 'websiteCards',
    jsonData: {
      "Filters": [
        {
          "FieldName": "TenantId",
          "FilterOperatorId": 1,
          "FieldValue": tenantId,
          "FieldType": "number"
        },
        {
          "FieldName": "PlatformWebSiteId",
          "FieldType": "number",
          "FilterOperatorId": 1,
          "FieldValue": parmas?.id
        }
      ],
      "PageNumber": 1,
      "PageSize": 50,
      "SortField": "Id",
      "SortOrder": "desc",
      }}))
  }
  const filterTypes = [{
    name: 'Text', value: "text"
  },
  {
    name: 'Number', value: "number"
  },
  {
    name: 'CheckBox', value: "checkbox"
  },
  {
    name: 'Date', value: "date"
  }
  ]
  useEffect(
    () => {
      dispatch(websites.list({ url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-websites/list`, entity: 'websites', jsonData: {} })).then(() => {
        dispatch(stores.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/stores/list`,
          entity: 'stores',
          jsonData: {
            "Filters": [
              {
                "FieldName": "TenantId",
                "FilterOperatorId": 1,
                "FieldValue": tenantId,
                "FieldType": "number"
              }
            ]
          }
        })).then(() => {
          dispatch(departments.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/hrms/departments/list`, entity: 'departments', jsonData: {

              Records: [
                {
                  Id: tenantId

                }
              ]

            }
          }))
        })
      })
      if (parmas?.id > 0) {
        createColumnDefs()
        setIsLoading(false)
        dispatch(websiteCards.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`,
          entity: 'websiteCards',
          jsonData: {
            "Filters": [
              {
                "FieldName": "TenantId",
                "FilterOperatorId": 1,
                "FieldValue": tenantId,
                "FieldType": "number"
              },
              {
                "FieldName": "PlatformWebSiteId",
                "FieldType": "number",
                "FilterOperatorId": 1,
                "FieldValue": parmas?.id
              }
            ],
          }
        }))
      }
      else {
        setIsLoading(false)
      }
    },
    []
  )
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)

  }
  const handleDelete = (data: any) => {
    dispatch(websiteCards.delete({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/delete`,
      entity: 'websiteCards',
      jsonData: {
        Records: [
          {
            "Context": {},
            "Message": { CardId: data?.Id }

          }
        ]
      }
    })).then(() => {
      dispatch(websiteCards.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`,
        entity: 'websiteCards',
        jsonData: {
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            },
            {
              "FieldName": "PlatformWebSiteId",
              "FieldType": "number",
              "FilterOperatorId": 1,
              "FieldValue": parmas?.id
            }
          ],
        }
      }))
    });

  }
  const additionButtons: any = [
    {
      name: 'Back',
      callback: () => back(),
    },
    {
      svg:
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
      <title>Reload</title>
      <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>,
    // name: 'Reload',
    callback: () => handleReloadData(),
    },
  ];
  const formatWebsiteListData = (data: any) => {
    return _.map(data, (product: any) => {

      const item = {
        Id: product?.message?.Id,
        WebsiteName: product?.message?.WebsiteName,


      }
      return item
    });
  }
  return (
    <>
      {isLoading ? <PageLoader /> :
        <WebsitesComponent
        onSearch={handleSearch}
          selectedTenantWebsites={selectedTenantWebsites}
          handleInnerFormChange={handleInnerFormChange}
          websites={formatWebsiteListData(websiteItems?.result?.items)}
          back={back}
          handleFormSubmit={handleFormSubmit}
          onDelete={handleDelete}
          onEdit={handleEdit}
          rowData={websiteCardsItems?.result?.items}
          columnDefs={columnDefs}
          Id={parmas?.id}
          additionButtons={additionButtons}
          stores={storeLists?.result?.items}
          departments={departmentLists?.result?.items}
        />
      }
    </>
  )

}

export default AgencyWebsite;